var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseNormal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636E95",
    fillRule: "nonzero",
    d: "M22.167 8.167h-3.5v-1.75c0-1.611-1.306-2.917-2.917-2.917h-3.5c-1.61 0-2.917 1.306-2.917 2.917v1.75h-3.5c-1.933 0-3.5 1.567-3.5 3.5V21c0 1.933 1.567 3.5 3.5 3.5h16.334c1.933 0 3.5-1.567 3.5-3.5v-9.333c0-1.933-1.567-3.5-3.5-3.5zM17.5 10.5v11.667h-7V10.5h7zm-5.833-4.083c0-.322.26-.584.583-.584h3.5c.322 0 .583.262.583.584v1.75h-4.666v-1.75zM4.667 21v-9.333c0-.645.522-1.167 1.166-1.167h2.334v11.667H5.833c-.644 0-1.166-.523-1.166-1.167zm18.666 0c0 .644-.522 1.167-1.166 1.167h-2.334V10.5h2.334c.644 0 1.166.522 1.166 1.167V21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseNormal);
export default __webpack_public_path__ + "static/media/briefcase-normal.33d2ea07a92fe0f429c3d841febeff5f.svg";
export { ForwardRef as ReactComponent };